import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      name: yup.string().nullable(),
      accountNumber: yup.string().nullable(),
      status: yup.string().nullable(),
      hasProfileWarnings: yup.string().nullable(),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'ATLEASTONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      value => Object.values(value).some(val => val && val !== ''),
    );

export default validationSchema;
